import { getUrl } from '../../../utils/api';

export const getVectorTileApi = (feature, source = {}) => {
  return source.url && source.token
    ? `${source.url}/map/tiles/${feature}/{z}/{x}/{y}?token=${source.token}`
    : getUrl(`map/tiles/${feature}/{z}/{x}/{y}`);
};
